import { DOCUMENT } from "@angular/common";
import { inject, Injectable, RendererFactory2 } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class FontLoaderService {
    private _rendererFactory = inject(RendererFactory2);
    private _document: Document = inject(DOCUMENT);

    loadMaterialIcons(){
        const renderer = this._rendererFactory.createRenderer(null, null);
        const link = renderer.createElement('link');
        renderer.setAttribute(link, 'rel', 'stylesheet');
        renderer.setAttribute(link, 'href', 'https://fonts.googleapis.com/icon?family=Material+Icons&display=swap');
        renderer.setAttribute(link, 'crossorigin', 'anonymous');
        renderer.appendChild(this._document.head, link);
    }
}